import React from 'react'
import Banner from '../../components/banner/Banner'
import InfoData from '../../components/infodata/InfoData'
import SocialMobile from '../../components/socialmobile/SocialMobile'
import './top.css'

const TopContent = () => {

      return (
            <div className="top_content">
                  <Banner />
                  <InfoData />
                  <SocialMobile />
            </div>
      )
}

export default TopContent
